import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { Config } from "../../config/environment";

/*
  Generated class for the IdomooProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

@Injectable()
export class IdomooProvider {

	reqBdy: any;
	vidLink: string = "";
  cloudName: string = "jandjstaging";
  constructor(public http: Http) {
    let idm = Config.idomoo;
  	let self = this;
    self.reqBdy = 
  	{
	    response_format: "json",
	    video: {
	        "output_formats": [
	            {
	                "format": idm.outFormat
	            }
	        ],
	        "data": [
	        	
	        	],
	        "storyboard_id": idm.storyboardId,
	        "account_id": idm.accountId,
		    "authentication_token": idm.secret,//"w0dvjVQZSNrFEZoeqRGjbA--",
		   // "landing_page_id":this.landPageId
	    }
	}
	//this.test();
  }

  testD():Promise<any>{
  	let self = this;
  	let hdr = new Headers();
  	hdr.append("Content-Type","application/json");
  	let rq = new RequestOptions({headers: hdr});
    let idm = Config.idomoo;
  	return this.http.post(idm.link, this.reqBdy, rq).toPromise()
  			.then(r=>{
  				let res = r.json();
  				console.log(res);
  				self.vidLink = res.video.output_formats[0].links[0].url;
  				console.log(self.vidLink);
  				localStorage.vid = self.vidLink;
  				self.storeLastPhoto();
  			}).catch(res=>{return Promise.reject("error")});
  }

  getUserPhotosFromStorage(){
  	let dataMap : Array<{key:string,val:string}> = [];
  	let cyg :Array<any> = eval(localStorage.cygHistory).slice(-30);
    let self = this;
  	return new Promise((resolve,reject)=>{
  		cyg.forEach((val,ind)=>{
	  		dataMap.push({"key":"DAY_"+(ind+1),"val":val['photoUrl']});
	  		dataMap.push({"key":"TEXT_"+(ind+1),"val":"DAY "+(ind+1)});
	  	});	
  		resolve(dataMap);
  	})
  	
  }

  imagga_crop(urli:string) : string{
    let url = urli.split("/").slice(-1)[0];
    let ret = `https://res.cloudinary.com/${this.cloudName}/image/upload/c_imagga_scale,h_400,w_225/`+url;
    //console.log(ret);
    return ret;
  }

  getLastPhoto(){
  	let lastPhoto = JSON.parse(localStorage.cygHistory);
  	return lastPhoto[lastPhoto.length-1]['photoUrl'];
  }

  storeLastPhoto(){
  	localStorage.lastPhoto = this.getLastPhoto();
  }

  generateVid():Promise<any>{
  	let self = this;
  	if(localStorage.lastPhoto == this.getLastPhoto()){
  		return Promise.resolve("same");
  	}
	return self.getUserPhotosFromStorage().then(res=>{
		self.reqBdy.video.data = res;
		return self.testD().catch(err=>{return Promise.reject("error")});
		
	});
  }
}





// WEBPACK FOOTER //
// ./src/providers/idomoo/idomoo.ts